<template>
    <div id="podbean-explorer">
        <button class="btn btn-white" @click="explore()">
            <i class="fa fa-podcast"></i>
        </button>

        <transition name="modal" v-if="showModal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div id="mapelModal" class="modal-container">
                        <div class="modal-header">
                            <h3>Pilih File Audio</h3>
                        </div>

                        <div class="modal-body">
                            <app-datatable
                                :items="rows"
                                :headers="headers"
                                :hasAction="false"
                                v-on:dblClicked="selectItem($event)"
                            ></app-datatable>
                        </div>

                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-danger"
                                @click="showModal = false"
                            >
                                Tutup
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import axios from "axios";
import DataTable from "@/modules/global/components/plugins/DataTable";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "podbean-explorer",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            showModal: false,
            isLoading: false,
            headers: ["Filename", "Date", "Preview"],
            rows: [],
            items: [],
        };
    },

    methods: {
        explore: function () {
            var context = this;
            var url = "https://anchor.fm/s/f78dcdc/podcast/rss";

            this.isLoading = true;
            this.rows = [];
            axios.get(url).then(function (response) {
                if (response.status === 200) {
                    var domParser = new DOMParser();
                    var xmlDoc = domParser.parseFromString(
                        response.data,
                        "text/xml",
                    );
                    var items = xmlDoc.getElementsByTagName("item");

                    for (var i = 0; i < items.length; i++) {
                        var item = items[i];
                        var url = item
                            .getElementsByTagName("enclosure")[0]
                            .getAttribute("url");
                        var row = {
                            id: i,
                            data: [
                                item.getElementsByTagName("title")[0]
                                    .textContent,
                                item.getElementsByTagName("pubDate")[0]
                                    .textContent,
                                '<a href="#" onClick="' +
                                    "window.open('" +
                                    url +
                                    "','MyWindow','width=350,height=50'); return false;" +
                                    '">Preview</a>',
                            ],
                        };

                        context.rows.push(row);
                        context.items.push(item);
                    }

                    context.isLoading = false;
                    context.showModal = true;
                }
            });
        },

        selectItem: function (item) {
            var item = this.items[item.id];
            var title = item.getElementsByTagName("title")[0].textContent;
            var resourceId = item
                .getElementsByTagName("link")[0]
                .textContent.split("/")[5];
            var link = "https://anchor.fm/nfjuara/embed/episodes/" + resourceId;
            var iframeString =
                '<iframe src="' +
                link +
                '" height="102px" width="100%" frameborder="0" scrolling="no"></iframe>';

            this.showModal = false;
            this.$emit("selected", iframeString);
        },
    },
};
</script>



// WEBPACK FOOTER //
// PodbeanExplorer.vue?3da856b7